module.exports = __webpack_public_path__ + "img/hj.94c41b5.png";